//FIXME check if realy usefull ?
export enum Lang {
  FRENCH = "fr-FR",
  ENGLISH = "en-US",
  GERMAN = "de-DE",
  SPANISH = "es-ES",
  ITALIAN = "it-IT",
}
export const LangToDateFormat: { [lang: string]: string } = {
  "fr-FR": "dd/MM/yyyy",
  "en-US": "MM/dd/yyyy",
  "en-GB": "dd/MM/yyyy",
  "de-DE": "dd/MM/yyyy",
  "es-ES": "dd/MM/yyyy",
  "it-IT": "dd/MM/yyyy",
};
